import styled from 'styled-components';
import { ColorSelectStyled } from '../ColorSelectStyled';
import { rem } from 'polished';

export const ColorSelectStyledAC = styled(ColorSelectStyled)`
    .name {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
    }

    .name,
    .price {
        color: ${({ theme }) => theme.colors.grey5};
    }
    .colorButton {
        &.is-selected {
            box-shadow: unset;
            outline: ${rem('2px')} solid ${({ theme }) => theme.colors.blue2};
        }

        &.enabled {
            &:hover,
            &:focus-visible {
                box-shadow: unset;
                outline: ${rem('2px')} solid ${({ theme }) => theme.colors.blue2};
            }
        }
    }
`;
